import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./nujobsdashboardstats.scss";

import { Card, Statistic } from "antd";

import {
  HeartOutlined,
  CalendarOutlined,
  EyeOutlined,
  FileTextOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import useNuJobsStore from "../../../store/nujobs.store";

function NuJobsDashboardStats() {

  const navigate = useNavigate();
  const { nujobsUserMetaDataStats, totalViewed, totalApplied, totalFavorite,nujobGetMyAppliedJobs,
         ViewedResponseMetadata,AppliedResponseMetadata,FavResponseMetadata,myResumes,nujobsGetMyResumes} = useNuJobDetailsStore();
  const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
  const { searchMetaData,setSearchMetaData } = useNuJobsStore();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const encodeJson = (page, pageSize) =>{
        let encodedJsonValues ={};
        encodedJsonValues.keywords= "";
        encodedJsonValues.city=null;
        encodedJsonValues.category=[];  
        encodedJsonValues.timestamp= 0;  
        encodedJsonValues.postingdate= "All"
        encodedJsonValues.pagenum= page;
        encodedJsonValues.maxPerPage= pageSize;

        //from values
        encodedJsonValues.minexp=null;
        encodedJsonValues.maxexp=null;  
        encodedJsonValues.minctc= null;  
        encodedJsonValues.maxctc= null
        encodedJsonValues.noticeperiod= []; 
        encodedJsonValues.postingdate=[];
        encodedJsonValues.workmode=null;  
        encodedJsonValues.diversity= null;  
        encodedJsonValues.role= []
        encodedJsonValues.roletype= []
        encodedJsonValues.companytype= null
        encodedJsonValues.jobfor= null      
        const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
        encodedJsonValues.nujuid= userData.nujuid   
        encodedJsonValues.nujoid= userData.nujoid
        encodedJsonValues.signedin= true
        encodedJsonValues.pendingsync = JSON.parse(
                    localStorage.getItem("NuJobsPendingSync") || "[]"
            );                
                                              
        return encodedJsonValues
    }
  
  useEffect(() => {
    // handle applynow before login
    nujobsUserMetaDataStats()
    nujobsGetMyResumes()

    const jasonValues = encodeJson(currentPage, pageSize)
    nujobGetMyAppliedJobs(jasonValues,setSearchMetaData)    
  }, []);

  const stats = [
    {
      title: "Applied Jobs",
      value: totalApplied !=null?totalApplied:0,
      icon: <FileDoneOutlined />,
      color: "#1677ff",
    },
    {
      title: "Saved Jobs",
      value: totalFavorite!=null?totalFavorite:0,
      icon: <HeartOutlined />,
      color: "#ff4d4f",
    },
    {
      title: "Jobs Viewed",
      value: totalViewed!=null?totalViewed:0,
      icon: <EyeOutlined />,
      color: "#faad14",
    },
    {
      title: "Resumes",
      value: myResumes?.filter((item) => item.resumestatus != "NO_RES")?.length,
      icon: <FileTextOutlined />,
      color: "#722ed1",
    },
  ];
  const handleClick = (item) =>{
    if(item.title =="Resumes"){
       navigate("/nujobshome/nujobsMyResumes")
    }else if(item.title=="Jobs Viewed"){
      setSearchMetaData(ViewedResponseMetadata)
       navigate("/nujobshome/nujobsViewedJobsSearchResults");
    }else if(item.title == "Saved Jobs"){
      setSearchMetaData(FavResponseMetadata)
       navigate("/nujobshome/nujobsFavJobsSearchResults")
    } else if ( item.title == "Applied Jobs"){
      setSearchMetaData(AppliedResponseMetadata)
      navigate("/nujobshome/nujobsAppliedJobsSearchResults")
    }
  }

  return (
    <div className="nujobsdashboardstats-wrapper">

      <div className="flexComponent-title-wrapper">
        My Applications and MyJobs
      </div>

      <div className="stats-grid">
        {stats.map((item) => (
          <Card
            key={item.title}
            hoverable
            className="dashboard-stat-card"
            onClick={() => handleClick(item)}
            
          >
            <div className="dashboard-stat-content">
              <div
                className="dashboard-stat-icon"
                style={{
                  background: `${item.color}15`,
                  color: item.color,
                }}
              >
                {item.icon}
              </div>
              <Statistic
                title={item.title}
                value={item.value}
                
              />
            </div>
          </Card>
        ))}

      </div>

    </div>
  );
}

export default NuJobsDashboardStats;